(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["available-deals"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__dealsJSLoaded) return;
    window.__dealsJSLoaded = true;

    function formatMoney(cents) {
      var dollars = cents / 100;
      return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // ── Buy-limit helpers (deal-level "select up to N of these products") ──
    // dealElement = the <dialog class="available-deals__dialog"> for one deal.

    // Reads the max number of qualifying products allowed for this deal.
    function getDealBuyLimit(dealElement) {
      var grid = dealElement.querySelector('[data-buy-limit]');
      return grid ? parseInt(grid.getAttribute('data-buy-limit'), 10) || 0 : 0;
    }

    // Counts qualifying products currently selected/added to cart for this deal.
    function getSelectedProductsCount(dealElement) {
      return dealElement.querySelectorAll('[data-qualifying-product][data-selected="true"]').length;
    }

    // Disables "Add to cart" for every unselected qualifying product once the
    // deal's buy limit is reached. Already-selected products are never
    // disabled so the customer can still remove them; when the count drops
    // back below the limit (remove/qty change), buttons unlock again.
    // Runs per-deal (dealElement scoped), so multiple deals stay independent.
    function updateDealAddToCartState(dealElement) {
      var buyLimit = getDealBuyLimit(dealElement);
      if (!buyLimit) return;

      var selectedCount = getSelectedProductsCount(dealElement);
      var limitReached = selectedCount >= buyLimit;

      dealElement.querySelectorAll('[data-qualifying-product]').forEach(function(card) {
        var atcBtn = card.querySelector('[data-atc-btn]');
        if (!atcBtn || atcBtn.classList.contains('deal-popup__atc-btn--soldout')) return;

        // Never touch a button mid-request (Adding…/Removing…).
        var busy = atcBtn.textContent.trim() === 'Adding…' || atcBtn.textContent.trim() === 'Removing…';
        if (busy) return;

        var isSelected = card.getAttribute('data-selected') === 'true';

        if (isSelected) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('deal-popup__atc-btn--limit-reached');
          card.classList.remove('deal-popup__atc-btn--limit-reached');
          return;
        }

        atcBtn.disabled = limitReached;
        atcBtn.classList.toggle('deal-popup__atc-btn--limit-reached', limitReached);
        // Keep the parent <li> card in sync with the button's limit-reached state.
        card.classList.toggle('deal-popup__atc-btn--limit-reached', limitReached);
      });
    }

    // Re-checks progress + buy-limit state for every open deal dialog. Called
    // after any cart mutation (add/remove/qty change/drawer re-render) so
    // each deal's UI stays synced in real time without a page refresh.
    function syncAllDealsState() {
      document.querySelectorAll('.available-deals__dialog[open]').forEach(updateDealProgress);
    }

    // function updateBundleBtn(dialog) {
    //   var bundleBtn = dialog.querySelector('[data-buy-bundle-btn]');
    //   if (!bundleBtn) return;

    //   var busy = bundleBtn.textContent.trim() === 'Adding\u2026' || bundleBtn.textContent.trim() === 'Bundle Added!';
    //   if (busy) return;

    //   bundleBtn.textContent = 'Buy Bundle';
    // }

    function updateBundleBtn(dialog) {
      var bundleBtn = dialog.querySelector('[data-buy-bundle-btn]');
      if (!bundleBtn) return;

      var text = bundleBtn.textContent.trim();

      if (text === 'Adding…') return;

      if (text === 'Bundle Added!') {
        bundleBtn.disabled = true;
        bundleBtn.setAttribute('aria-disabled', 'true');
        return;
      }

      bundleBtn.disabled = false;
      bundleBtn.removeAttribute('aria-disabled');
      bundleBtn.textContent = 'Buy Bundle';
    }

    function updateDealProgress(dialog) {
      var slots = dialog.querySelectorAll('[data-progress-slot]');
      var countEl = dialog.querySelector('[data-progress-count]');
      var cards = dialog.querySelectorAll('[data-qualifying-product]');
      if (!slots.length && !countEl) return;

      var qualifyingIds = Array.prototype.map.call(cards, function(c) {
        return String(c.getAttribute('data-product-id'));
      });

      fetch('/cart.json')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var cartIds = cart.items.map(function(i) { return String(i.product_id); });
          var cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });
          var addedIds = qualifyingIds.filter(function(id) { return cartIds.indexOf(id) > -1; });

          if (countEl) countEl.textContent = addedIds.length;

          slots.forEach(function(slot) {
            var inCart = addedIds.indexOf(slot.getAttribute('data-product-id')) > -1;
            slot.classList.toggle('deal-popup__progress-slot--added', inCart);
          });

          cards.forEach(function(card) {
            var inCart = addedIds.indexOf(card.getAttribute('data-product-id')) > -1;
            card.classList.toggle('deal-popup__product-card--added', inCart);
            // Track selection explicitly so the buy-limit check doesn't need another cart fetch.
            card.setAttribute('data-selected', inCart ? 'true' : 'false');
            var atcBtn = card.querySelector('[data-atc-btn]');
            if (atcBtn && !atcBtn.classList.contains('deal-popup__atc-btn--soldout')) {
              var busy = atcBtn.textContent.trim() === 'Removing…' || atcBtn.textContent.trim() === 'Adding…';
              if (!busy) {
                if (inCart) {
                  atcBtn.setAttribute('data-in-cart', 'true');
                  atcBtn.textContent = 'Remove';
                } else {
                  atcBtn.removeAttribute('data-in-cart');
                  atcBtn.textContent = 'Add to cart';
                }
              }
            }
          });

          // Enforce the deal-level buy limit (locks unselected products once reached).
          updateDealAddToCartState(dialog);

          // Shared: buy limit and remaining count
          var grid = dialog.querySelector('[data-buy-limit]');
          var buyLimit = grid ? parseInt(grid.getAttribute('data-buy-limit'), 10) : 0;
          var remaining = Math.max(0, buyLimit - addedIds.length);

          // Step 2: free-gift status indicator ONLY — never manually
          // clickable. It is always kept disabled; adding/removing it to/from
          // the cart is handled exclusively by syncFreeGiftWithBuyLimit()
          // based on the qualifying product count vs. the buy limit.
          var giftBtn = dialog.querySelector('[data-free-gift-btn]');
          if (giftBtn) {
            var giftVariantId = giftBtn.getAttribute('data-variant-id');
            var giftInCart = giftVariantId && cartVariantIds.indexOf(String(giftVariantId)) > -1;

            giftBtn.disabled = true;

            if (remaining === 0) {
              giftBtn.classList.remove('deal-popup__atc-btn--locked');
              if (giftInCart) {
                giftBtn.setAttribute('data-in-cart', 'true');
                giftBtn.textContent = 'Added Free ✓';
              } else {
                giftBtn.removeAttribute('data-in-cart');
                giftBtn.textContent = 'Unlocked ✓';
              }
            } else {
              giftBtn.classList.add('deal-popup__atc-btn--locked');
              giftBtn.removeAttribute('data-in-cart');
              giftBtn.textContent = 'Unlock Free';
            }
          }

          // Bundle Status update
          var bundleStatus = dialog.querySelector('[data-bundle-status]');
          if (bundleStatus) {
            var addedCountEls = bundleStatus.querySelectorAll('[data-bundle-added-count]');
            var addedListEl = bundleStatus.querySelector('[data-bundle-added-list]');
            var remainingCountEl = bundleStatus.querySelector('[data-bundle-remaining-count]');
            var remainingTextEl = bundleStatus.querySelector('[data-bundle-remaining-text]');
            var giftStatusEl = bundleStatus.querySelector('[data-bundle-gift-status]');

            addedCountEls.forEach(function(el) { el.textContent = addedIds.length; });

            if (addedListEl) {
              addedListEl.innerHTML = '';
              var hasAdded = false;
              cards.forEach(function(card) {
                if (addedIds.indexOf(card.getAttribute('data-product-id')) > -1) {
                  hasAdded = true;
                  var titleEl = card.querySelector('.deal-popup__product-title');
                  var li = document.createElement('li');
                  li.textContent = titleEl ? titleEl.textContent : '';
                  addedListEl.appendChild(li);
                }
              });
              if (!hasAdded) {
                var emptyLi = document.createElement('li');
                emptyLi.className = 'deal-popup__bundle-empty';
                emptyLi.textContent = 'None yet';
                addedListEl.appendChild(emptyLi);
              }
            }

            if (remainingCountEl) remainingCountEl.textContent = remaining;
            if (remainingTextEl) {
              remainingTextEl.textContent = remaining > 0
                ? remaining + ' Item' + (remaining !== 1 ? 's' : '') + ' Remaining'
                : 'All items added!';
            }

            if (giftStatusEl) {
              if (remaining === 0) {
                giftStatusEl.textContent = 'Unlocked ✓';
                giftStatusEl.classList.add('deal-popup__bundle-gift-status--unlocked');
              } else {
                giftStatusEl.textContent = 'Pending (Require ' + buyLimit + ' items)';
                giftStatusEl.classList.remove('deal-popup__bundle-gift-status--unlocked');
              }
            }
          }

          updateBundleBtn(dialog);
        })
        .catch(function(e) { console.warn('[available-deals] cart fetch error', e); });
    }

    // Auto-syncs each deal's free gift with its buy-limit state:
    //  - ADD:    once the qualifying product count reaches the buy limit, the
    //            free gift is added to the cart automatically (no manual click).
    //  - REMOVE: if the qualifying count drops back below the limit (product
    //            removed / cart line set to 0), the free gift is auto-removed.
    // A single in-flight guard (_freeGiftSyncInProgress) prevents overlapping
    // /cart requests and infinite update loops when our own mutation
    // re-triggers the cart-changed listener below.
    var _freeGiftSyncInProgress = false;
    function syncFreeGiftWithBuyLimit() {
      if (_freeGiftSyncInProgress) return;
      _freeGiftSyncInProgress = true;

      fetch('/cart.json')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var cartProductIds = cart.items.map(function(i) { return String(i.product_id); });
          var cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });

          var removeUpdates = {};
          var addItems = [];
          var seenAddVariant = {}; // de-dupe: multiple deals could share the same gift variant

          document.querySelectorAll('.available-deals__dialog').forEach(function(dialog) {
            var cards = dialog.querySelectorAll('[data-qualifying-product]');
            var grid = dialog.querySelector('[data-buy-limit]');
            var giftBtn = dialog.querySelector('[data-free-gift-btn]');
            if (!grid || !giftBtn) return;

            var buyLimit = parseInt(grid.getAttribute('data-buy-limit'), 10);
            var giftVariantId = giftBtn.getAttribute('data-variant-id');
            if (!buyLimit || !giftVariantId) return;

            var qualifyingIds = Array.prototype.map.call(cards, function(c) {
              return String(c.getAttribute('data-product-id'));
            });
            var addedCount = qualifyingIds.filter(function(id) {
              return cartProductIds.indexOf(id) > -1;
            }).length;
            var giftInCart = cartVariantIds.indexOf(String(giftVariantId)) > -1;

            if (addedCount >= buyLimit) {
              // Buy limit satisfied — auto-unlock the free gift if not already in cart.
              if (!giftInCart && !seenAddVariant[giftVariantId]) {
                seenAddVariant[giftVariantId] = true;
                addItems.push({
                  id: parseInt(giftVariantId, 10),
                  quantity: 1,
                  properties: { '_free_gift': 'true', '_deal_gift': 'true' }
                });
              }
            } else if (giftInCart) {
              // Qualifying count dropped below the limit — auto-remove the gift.
              removeUpdates[giftVariantId] = 0;
            }
          });

          var hasRemovals = Object.keys(removeUpdates).length > 0;
          var hasAdditions = addItems.length > 0;

          if (!hasRemovals && !hasAdditions) {
            _freeGiftSyncInProgress = false;
            return;
          }

          var requests = [];
          if (hasRemovals) {
            requests.push(fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ updates: removeUpdates })
            }));
          }
          if (hasAdditions) {
            requests.push(fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: addItems })
            }));
          }

          Promise.all(requests)
            .then(function() {
              _freeGiftSyncInProgress = false;
              syncAllDealsState();
              ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(n) {
                document.dispatchEvent(new CustomEvent(n));
              });
              refreshCartSilently();
            })
            .catch(function(e) {
              _freeGiftSyncInProgress = false;
              console.warn('[available-deals] free gift auto-sync error', e);
            });
        })
        .catch(function(e) {
          _freeGiftSyncInProgress = false;
          console.warn('[available-deals] cart fetch error (free gift sync)', e);
        });
    }

    // Refresh cart drawer content WITHOUT opening it
    function refreshCartSilently() {
      var cartItemsEl = document.querySelector('cart-items');
      if (!cartItemsEl || typeof cartItemsEl.getCart !== 'function') return;

      var cartDrawerEl = document.querySelector('cart-drawer');
      var drawerAlreadyOpen = cartDrawerEl ? cartDrawerEl.cartDrawerIsOpen : true;

      if (cartDrawerEl && !drawerAlreadyOpen) {
        // Temporarily mark drawer as open so openCartDrawerOnProductAdded skips it
        cartDrawerEl.cartDrawerIsOpen = true;
        var resetFlag = function() {
          // Reset AFTER the theme:product:added handlers finish
          setTimeout(function() {
            if (cartDrawerEl) cartDrawerEl.cartDrawerIsOpen = false;
          }, 0);
          document.removeEventListener('theme:product:added', resetFlag);
        };
        document.addEventListener('theme:product:added', resetFlag);
      }

      cartItemsEl.getCart();
    }

    function initAvailableDeals() {
      // Use event delegation for [data-deals-trigger] so handlers survive
      // cart drawer AJAX re-renders (DOM is replaced on every cart change,
      // which would destroy direct element listeners).
      document.addEventListener('click', function(e) {
        var trigger = e.target.closest('[data-deals-trigger]');
        if (!trigger) return;
        var dialogId = trigger.getAttribute('data-deals-trigger');
        var dialog = document.getElementById(dialogId);
        if (!dialog) return;
        // Guard against rapid/repeated clicks: showModal() throws if the dialog is already open.
        if (dialog.open) return;
        dialog.showModal();
        dialog.setAttribute('aria-hidden', 'false');
        updateBundleBtn(dialog);
        updateDealProgress(dialog);
      });

      document.querySelectorAll('[data-deals-close]').forEach(function(btn) {
        var dialogId = btn.getAttribute('data-deals-close');
        var dialog = document.getElementById(dialogId);
        if (!dialog) return;

        btn.addEventListener('click', function() {
          dialog.close();
        });
      });

      // Re-check progress when cart is updated (covers common theme event names)
      ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(evtName) {
        document.addEventListener(evtName, function() {
          syncAllDealsState();
          syncFreeGiftWithBuyLimit();
        });
      });

      document.querySelectorAll('[data-copy-code]').forEach(function(codeEl) {
        codeEl.setAttribute('role', 'button');
        codeEl.setAttribute('tabindex', '0');
        codeEl.title = 'Click to copy code';

        function copyCode() {
          var code = codeEl.getAttribute('data-copy-code');
          if (!code) return;
          if (navigator.clipboard) {
            navigator.clipboard.writeText(code).then(function() {
              showCopied(codeEl);
            });
          } else {
            var tmp = document.createElement('input');
            tmp.value = code;
            document.body.appendChild(tmp);
            tmp.select();
            document.execCommand('copy');
            document.body.removeChild(tmp);
            showCopied(codeEl);
          }
        }

        codeEl.addEventListener('click', copyCode);
        codeEl.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            copyCode();
          }
        });
      });

      // Add-to-cart / Remove handler (delegated, handles all deal popups)
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-atc-btn]');
        if (!btn) return;

        // The free-gift button is a status indicator only — it must never be
        // added/removed manually. syncFreeGiftWithBuyLimit() owns it entirely.
        if (btn.hasAttribute('data-free-gift-btn')) return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;

        // REMOVE mode
        if (btn.getAttribute('data-in-cart') === 'true') {
          btn.disabled = true;
          btn.textContent = 'Removing…';

          var removeUpdates = {};
          removeUpdates[variantId] = 0;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ updates: removeUpdates })
          })
            .then(function(r) {
              if (!r.ok) throw new Error('Cart remove failed: ' + r.status);
              return r.json();
            })
            .then(function() {
              btn.removeAttribute('data-in-cart');
              btn.textContent = 'Add to cart';
              btn.disabled = false;
              syncAllDealsState();
              ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(n) {
                document.dispatchEvent(new CustomEvent(n));
              });
              refreshCartSilently();
            })
            .catch(function(err) {
              console.warn('[available-deals] remove-from-cart error', err);
              btn.disabled = false;
              btn.textContent = 'Remove';
            });
          return;
        }

        // ADD mode
        btn.disabled = true;
        btn.textContent = 'Adding…';

        var addPayload = { id: parseInt(variantId, 10), quantity: 1 };
        if (btn.hasAttribute('data-free-gift-btn')) {
          addPayload.properties = { '_free_gift': 'true', '_deal_gift': 'true' };
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(addPayload)
        })
          .then(function(r) { return r.json(); })
          .then(function() {
            btn.setAttribute('data-in-cart', 'true');
            btn.textContent = 'Remove';
            btn.disabled = false;
            syncAllDealsState();
            ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(n) {
              document.dispatchEvent(new CustomEvent(n));
            });
            refreshCartSilently();
          })
          .catch(function(err) {
            console.warn('[available-deals] add-to-cart error', err);
            btn.disabled = false;
            btn.textContent = 'Add to cart';
          });
      });

      // Buy Bundle handler — adds all missing qualifying products + free gift in one request
      document.addEventListener('click', function(e) {
        var bundleBtn = e.target.closest('[data-buy-bundle-btn]');
        if (!bundleBtn || bundleBtn.disabled) return;

        var dialog = bundleBtn.closest('.available-deals__dialog');
        if (!dialog) return;

        var items = [];

        dialog.querySelectorAll('[data-qualifying-product]').forEach(function(card) {
          if (!card.classList.contains('deal-popup__product-card--added')) {
            var atcBtn = card.querySelector('[data-atc-btn]');
            var variantId = atcBtn ? atcBtn.getAttribute('data-variant-id') : null;
            if (variantId) items.push({ id: parseInt(variantId, 10), quantity: 1 });
          }
        });

        var giftBtn = dialog.querySelector('[data-free-gift-btn]');
        if (giftBtn && giftBtn.getAttribute('data-variant-id')) {
          items.push({ id: parseInt(giftBtn.getAttribute('data-variant-id'), 10), quantity: 1, properties: { '_free_gift': 'true', '_deal_gift': 'true' } });
        }

        if (!items.length) return;

        bundleBtn.disabled = true;
        bundleBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
          .then(function(r) { return r.json(); })
          .then(function() {
            bundleBtn.textContent = 'Bundle Added!';
            syncAllDealsState();
            ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(n) {
              document.dispatchEvent(new CustomEvent(n));
            });
            refreshCartSilently();
            setTimeout(function() {
              bundleBtn.disabled = false;
              updateBundleBtn(dialog);
            }, 2200);
          })
          .catch(function(err) {
            console.warn('[available-deals] buy bundle error', err);
            bundleBtn.disabled = false;
            updateBundleBtn(dialog);
          });
      });
    }

    function showCopied(el) {
      var original = el.querySelector('.available-deal-item__code-label');
      if (!original) return;
      var prev = original.textContent;
      original.textContent = 'Copied!';
      setTimeout(function() { original.textContent = prev; }, 1800);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAvailableDeals);
    } else {
      initAvailableDeals();
    }

    // On page load, reconcile free gifts against whatever is already in the
    // cart (e.g. a returning visitor whose cart already meets a deal's buy
    // limit) without requiring the customer to open the deal dialog first.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFreeGiftWithBuyLimit);
    } else {
      syncFreeGiftWithBuyLimit();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-deals-popup"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__dealsJSLoaded) return;
    window.__dealsJSLoaded = true;

    function formatMoney(cents) {
      var dollars = cents / 100;
      return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // ── Buy-limit helpers (deal-level "select up to N of these products") ──
    // dealElement = the <dialog class="available-deals__dialog"> for one deal.

    // Reads the max number of qualifying products allowed for this deal.
    function getDealBuyLimit(dealElement) {
      var grid = dealElement.querySelector('[data-buy-limit]');
      return grid ? parseInt(grid.getAttribute('data-buy-limit'), 10) || 0 : 0;
    }

    // Counts qualifying products currently selected/added to cart for this deal.
    function getSelectedProductsCount(dealElement) {
      return dealElement.querySelectorAll('[data-qualifying-product][data-selected="true"]').length;
    }

    // Disables "Add to cart" for every unselected qualifying product once the
    // deal's buy limit is reached. Already-selected products are never
    // disabled so the customer can still remove them; when the count drops
    // back below the limit (remove/qty change), buttons unlock again.
    // Runs per-deal (dealElement scoped), so multiple deals stay independent.
    function updateDealAddToCartState(dealElement) {
      var buyLimit = getDealBuyLimit(dealElement);
      if (!buyLimit) return;

      var selectedCount = getSelectedProductsCount(dealElement);
      var limitReached = selectedCount >= buyLimit;

      dealElement.querySelectorAll('[data-qualifying-product]').forEach(function(card) {
        var atcBtn = card.querySelector('[data-atc-btn]');
        if (!atcBtn || atcBtn.classList.contains('deal-popup__atc-btn--soldout')) return;

        // Never touch a button mid-request (Adding…/Removing…).
        var busy = atcBtn.textContent.trim() === 'Adding…' || atcBtn.textContent.trim() === 'Removing…';
        if (busy) return;

        var isSelected = card.getAttribute('data-selected') === 'true';

        if (isSelected) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('deal-popup__atc-btn--limit-reached');
          card.classList.remove('deal-popup__atc-btn--limit-reached');
          return;
        }

        atcBtn.disabled = limitReached;
        atcBtn.classList.toggle('deal-popup__atc-btn--limit-reached', limitReached);
        // Keep the parent <li> card in sync with the button's limit-reached state.
        card.classList.toggle('deal-popup__atc-btn--limit-reached', limitReached);
      });
    }

    // Re-checks progress + buy-limit state for every open deal dialog. Called
    // after any cart mutation (add/remove/qty change/drawer re-render) so
    // each deal's UI stays synced in real time without a page refresh.
    function syncAllDealsState() {
      document.querySelectorAll('.available-deals__dialog[open]').forEach(updateDealProgress);
    }

    function updateBundleBtn(dialog) {
      var bundleBtn = dialog.querySelector('[data-buy-bundle-btn]');
      if (!bundleBtn) return;

      var busy = bundleBtn.textContent.trim() === 'Adding\u2026' || bundleBtn.textContent.trim() === 'Bundle Added!';
      if (busy) return;

      bundleBtn.textContent = 'Buy Bundle';
    }

    function updateDealProgress(dialog) {
      var slots = dialog.querySelectorAll('[data-progress-slot]');
      var countEl = dialog.querySelector('[data-progress-count]');
      var cards = dialog.querySelectorAll('[data-qualifying-product]');
      if (!slots.length && !countEl) return;

      var qualifyingIds = Array.prototype.map.call(cards, function(c) {
        return String(c.getAttribute('data-product-id'));
      });

      fetch('/cart.json')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var cartIds = cart.items.map(function(i) { return String(i.product_id); });
          var cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });
          var addedIds = qualifyingIds.filter(function(id) { return cartIds.indexOf(id) > -1; });

          if (countEl) countEl.textContent = addedIds.length;

          slots.forEach(function(slot) {
            var inCart = addedIds.indexOf(slot.getAttribute('data-product-id')) > -1;
            slot.classList.toggle('deal-popup__progress-slot--added', inCart);
          });

          cards.forEach(function(card) {
            var inCart = addedIds.indexOf(card.getAttribute('data-product-id')) > -1;
            card.classList.toggle('deal-popup__product-card--added', inCart);
            // Track selection explicitly so the buy-limit check doesn't need another cart fetch.
            card.setAttribute('data-selected', inCart ? 'true' : 'false');
            var atcBtn = card.querySelector('[data-atc-btn]');
            if (atcBtn && !atcBtn.classList.contains('deal-popup__atc-btn--soldout')) {
              var busy = atcBtn.textContent.trim() === 'Removing…' || atcBtn.textContent.trim() === 'Adding…';
              if (!busy) {
                if (inCart) {
                  atcBtn.setAttribute('data-in-cart', 'true');
                  atcBtn.textContent = 'Remove';
                } else {
                  atcBtn.removeAttribute('data-in-cart');
                  atcBtn.textContent = 'Add to cart';
                }
              }
            }
          });

          // Enforce the deal-level buy limit (locks unselected products once reached).
          updateDealAddToCartState(dialog);

          var grid = dialog.querySelector('[data-buy-limit]');
          var buyLimit = grid ? parseInt(grid.getAttribute('data-buy-limit'), 10) : 0;
          var remaining = Math.max(0, buyLimit - addedIds.length);

          // Step 2: free-gift status indicator ONLY — never manually
          // clickable. It is always kept disabled; adding/removing it to/from
          // the cart is handled exclusively by syncFreeGiftWithBuyLimit()
          // based on the qualifying product count vs. the buy limit.
          var giftBtn = dialog.querySelector('[data-free-gift-btn]');
          if (giftBtn) {
            var giftVariantId = giftBtn.getAttribute('data-variant-id');
            var giftInCart = giftVariantId && cartVariantIds.indexOf(String(giftVariantId)) > -1;

            giftBtn.disabled = true;

            if (remaining === 0) {
              giftBtn.classList.remove('deal-popup__atc-btn--locked');
              if (giftInCart) {
                giftBtn.setAttribute('data-in-cart', 'true');
                giftBtn.textContent = 'Added Free ✓';
              } else {
                giftBtn.removeAttribute('data-in-cart');
                giftBtn.textContent = 'Unlocked ✓';
              }
            } else {
              giftBtn.classList.add('deal-popup__atc-btn--locked');
              giftBtn.removeAttribute('data-in-cart');
              giftBtn.textContent = 'Unlock Free';
            }
          }

          var bundleStatus = dialog.querySelector('[data-bundle-status]');
          if (bundleStatus) {
            var addedCountEls = bundleStatus.querySelectorAll('[data-bundle-added-count]');
            var addedListEl = bundleStatus.querySelector('[data-bundle-added-list]');
            var remainingCountEl = bundleStatus.querySelector('[data-bundle-remaining-count]');
            var remainingTextEl = bundleStatus.querySelector('[data-bundle-remaining-text]');
            var giftStatusEl = bundleStatus.querySelector('[data-bundle-gift-status]');

            addedCountEls.forEach(function(el) { el.textContent = addedIds.length; });

            if (addedListEl) {
              addedListEl.innerHTML = '';
              var hasAdded = false;
              cards.forEach(function(card) {
                if (addedIds.indexOf(card.getAttribute('data-product-id')) > -1) {
                  hasAdded = true;
                  var titleEl = card.querySelector('.deal-popup__product-title');
                  var li = document.createElement('li');
                  li.textContent = titleEl ? titleEl.textContent : '';
                  addedListEl.appendChild(li);
                }
              });
              if (!hasAdded) {
                var emptyLi = document.createElement('li');
                emptyLi.className = 'deal-popup__bundle-empty';
                emptyLi.textContent = 'None yet';
                addedListEl.appendChild(emptyLi);
              }
            }

            if (remainingCountEl) remainingCountEl.textContent = remaining;
            if (remainingTextEl) {
              remainingTextEl.textContent = remaining > 0
                ? remaining + ' Item' + (remaining !== 1 ? 's' : '') + ' Remaining'
                : 'All items added!';
            }

            if (giftStatusEl) {
              if (remaining === 0) {
                giftStatusEl.textContent = 'Unlocked ✓';
                giftStatusEl.classList.add('deal-popup__bundle-gift-status--unlocked');
              } else {
                giftStatusEl.textContent = 'Pending (Require ' + buyLimit + ' items)';
                giftStatusEl.classList.remove('deal-popup__bundle-gift-status--unlocked');
              }
            }
          }

          updateBundleBtn(dialog);
        })
        .catch(function(e) { console.warn('[available-deals] cart fetch error', e); });
    }

    // Auto-syncs each deal's free gift with its buy-limit state:
    //  - ADD:    once the qualifying product count reaches the buy limit, the
    //            free gift is added to the cart automatically (no manual click).
    //  - REMOVE: if the qualifying count drops back below the limit (product
    //            removed / cart line set to 0), the free gift is auto-removed.
    // A single in-flight guard (_freeGiftSyncInProgress) prevents overlapping
    // /cart requests and infinite update loops when our own mutation
    // re-triggers the cart-changed listener below.
    var _freeGiftSyncInProgress = false;
    function syncFreeGiftWithBuyLimit() {
      if (_freeGiftSyncInProgress) return;
      _freeGiftSyncInProgress = true;

      fetch('/cart.json')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var cartProductIds = cart.items.map(function(i) { return String(i.product_id); });
          var cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });

          var removeUpdates = {};
          var addItems = [];
          var seenAddVariant = {}; // de-dupe: multiple deals could share the same gift variant

          document.querySelectorAll('.available-deals__dialog').forEach(function(dialog) {
            var cards = dialog.querySelectorAll('[data-qualifying-product]');
            var grid = dialog.querySelector('[data-buy-limit]');
            var giftBtn = dialog.querySelector('[data-free-gift-btn]');
            if (!grid || !giftBtn) return;

            var buyLimit = parseInt(grid.getAttribute('data-buy-limit'), 10);
            var giftVariantId = giftBtn.getAttribute('data-variant-id');
            if (!buyLimit || !giftVariantId) return;

            var qualifyingIds = Array.prototype.map.call(cards, function(c) {
              return String(c.getAttribute('data-product-id'));
            });
            var addedCount = qualifyingIds.filter(function(id) {
              return cartProductIds.indexOf(id) > -1;
            }).length;
            var giftInCart = cartVariantIds.indexOf(String(giftVariantId)) > -1;

            if (addedCount >= buyLimit) {
              // Buy limit satisfied — auto-unlock the free gift if not already in cart.
              if (!giftInCart && !seenAddVariant[giftVariantId]) {
                seenAddVariant[giftVariantId] = true;
                addItems.push({
                  id: parseInt(giftVariantId, 10),
                  quantity: 1,
                  properties: { '_free_gift': 'true', '_deal_gift': 'true' }
                });
              }
            } else if (giftInCart) {
              // Qualifying count dropped below the limit — auto-remove the gift.
              removeUpdates[giftVariantId] = 0;
            }
          });

          var hasRemovals = Object.keys(removeUpdates).length > 0;
          var hasAdditions = addItems.length > 0;

          if (!hasRemovals && !hasAdditions) {
            _freeGiftSyncInProgress = false;
            return;
          }

          var requests = [];
          if (hasRemovals) {
            requests.push(fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ updates: removeUpdates })
            }));
          }
          if (hasAdditions) {
            requests.push(fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: addItems })
            }));
          }

          Promise.all(requests)
            .then(function() {
              _freeGiftSyncInProgress = false;
              syncAllDealsState();
              ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(n) {
                document.dispatchEvent(new CustomEvent(n));
              });
              refreshCartSilently();
            })
            .catch(function(e) {
              _freeGiftSyncInProgress = false;
              console.warn('[available-deals] free gift auto-sync error', e);
            });
        })
        .catch(function(e) {
          _freeGiftSyncInProgress = false;
          console.warn('[available-deals] cart fetch error (free gift sync)', e);
        });
    }

    function refreshCartSilently() {
      var cartItemsEl = document.querySelector('cart-items');
      if (!cartItemsEl || typeof cartItemsEl.getCart !== 'function') return;

      var cartDrawerEl = document.querySelector('cart-drawer');
      var drawerAlreadyOpen = cartDrawerEl ? cartDrawerEl.cartDrawerIsOpen : true;

      if (cartDrawerEl && !drawerAlreadyOpen) {
        cartDrawerEl.cartDrawerIsOpen = true;
        var resetFlag = function() {
          setTimeout(function() {
            if (cartDrawerEl) cartDrawerEl.cartDrawerIsOpen = false;
          }, 0);
          document.removeEventListener('theme:product:added', resetFlag);
        };
        document.addEventListener('theme:product:added', resetFlag);
      }

      cartItemsEl.getCart();
    }

    function initAvailableDeals() {
      // Use event delegation for [data-deals-trigger] so handlers survive
      // cart drawer AJAX re-renders (cart-line-items DOM is replaced on every
      // cart change, which would destroy direct element listeners).
      document.addEventListener('click', function(e) {
        var trigger = e.target.closest('[data-deals-trigger]');
        if (!trigger) return;
        var dialogId = trigger.getAttribute('data-deals-trigger');
        var dialog = document.getElementById(dialogId);
        if (!dialog) return;
        // Guard against rapid/repeated clicks: showModal() throws if the dialog is already open.
        if (dialog.open) return;
        dialog.showModal();
        dialog.setAttribute('aria-hidden', 'false');
        updateBundleBtn(dialog);
        updateDealProgress(dialog);
      });

      ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(evtName) {
        document.addEventListener(evtName, function() {
          syncAllDealsState();
          syncFreeGiftWithBuyLimit();
        });
      });

      document.querySelectorAll('[data-copy-code]').forEach(function(codeEl) {
        codeEl.setAttribute('role', 'button');
        codeEl.setAttribute('tabindex', '0');
        codeEl.title = 'Click to copy code';

        function copyCode() {
          var code = codeEl.getAttribute('data-copy-code');
          if (!code) return;
          if (navigator.clipboard) {
            navigator.clipboard.writeText(code).then(function() {
              showCopied(codeEl);
            });
          } else {
            var tmp = document.createElement('input');
            tmp.value = code;
            document.body.appendChild(tmp);
            tmp.select();
            document.execCommand('copy');
            document.body.removeChild(tmp);
            showCopied(codeEl);
          }
        }

        codeEl.addEventListener('click', copyCode);
        codeEl.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            copyCode();
          }
        });
      });

      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-atc-btn]');
        if (!btn) return;

        // The free-gift button is a status indicator only — it must never be
        // added/removed manually. syncFreeGiftWithBuyLimit() owns it entirely.
        if (btn.hasAttribute('data-free-gift-btn')) return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;

        if (btn.getAttribute('data-in-cart') === 'true') {
          btn.disabled = true;
          btn.textContent = 'Removing…';

          var removeUpdates = {};
          removeUpdates[variantId] = 0;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ updates: removeUpdates })
          })
            .then(function(r) {
              if (!r.ok) throw new Error('Cart remove failed: ' + r.status);
              return r.json();
            })
            .then(function() {
              btn.removeAttribute('data-in-cart');
              btn.textContent = 'Add to cart';
              btn.disabled = false;
              syncAllDealsState();
              ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(n) {
                document.dispatchEvent(new CustomEvent(n));
              });
              refreshCartSilently();
            })
            .catch(function(err) {
              console.warn('[available-deals] remove-from-cart error', err);
              btn.disabled = false;
              btn.textContent = 'Remove';
            });
          return;
        }

        btn.disabled = true;
        btn.textContent = 'Adding…';

        var addPayload = { id: parseInt(variantId, 10), quantity: 1 };
        if (btn.hasAttribute('data-free-gift-btn')) {
          // _deal_gift marks this as a deals-popup gift so the GWP handler
          // (free-gift-handler.js) never mistakes it for a GWP tier gift and removes it.
          // _free_gift is kept so the GWP handler excludes this item from its
          // cart-total threshold calculation (preventing double-counting).
          addPayload.properties = { '_free_gift': 'true', '_deal_gift': 'true' };
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(addPayload)
        })
          .then(function(r) { return r.json(); })
          .then(function() {
            btn.setAttribute('data-in-cart', 'true');
            btn.textContent = 'Remove';
            btn.disabled = false;
            syncAllDealsState();
            ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(n) {
              document.dispatchEvent(new CustomEvent(n));
            });
            refreshCartSilently();
          })
          .catch(function(err) {
            console.warn('[available-deals] add-to-cart error', err);
            btn.disabled = false;
            btn.textContent = 'Add to cart';
          });
      });

      document.addEventListener('click', function(e) {
        var bundleBtn = e.target.closest('[data-buy-bundle-btn]');
        if (!bundleBtn || bundleBtn.disabled) return;

        var dialog = bundleBtn.closest('.available-deals__dialog');
        if (!dialog) return;

        var items = [];

        dialog.querySelectorAll('[data-qualifying-product]').forEach(function(card) {
          if (!card.classList.contains('deal-popup__product-card--added')) {
            var atcBtn = card.querySelector('[data-atc-btn]');
            var variantId = atcBtn ? atcBtn.getAttribute('data-variant-id') : null;
            if (variantId) items.push({ id: parseInt(variantId, 10), quantity: 1 });
          }
        });

        var giftBtn = dialog.querySelector('[data-free-gift-btn]');
        if (giftBtn && giftBtn.getAttribute('data-variant-id')) {
          items.push({ id: parseInt(giftBtn.getAttribute('data-variant-id'), 10), quantity: 1, properties: { '_free_gift': 'true', '_deal_gift': 'true' } });
        }

        if (!items.length) return;

        bundleBtn.disabled = true;
        bundleBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
          .then(function(r) { return r.json(); })
          .then(function() {
            bundleBtn.textContent = 'Bundle Added!';
            syncAllDealsState();
            ['cart:updated', 'theme:cart:change', 'cart-changed'].forEach(function(n) {
              document.dispatchEvent(new CustomEvent(n));
            });
            refreshCartSilently();
            setTimeout(function() {
              bundleBtn.disabled = false;
              updateBundleBtn(dialog);
            }, 2200);
          })
          .catch(function(err) {
            console.warn('[available-deals] buy bundle error', err);
            bundleBtn.disabled = false;
            updateBundleBtn(dialog);
          });
      });
    }

    function showCopied(el) {
      var original = el.querySelector('.available-deal-item__code-label');
      if (!original) return;
      var prev = original.textContent;
      original.textContent = 'Copied!';
      setTimeout(function() { original.textContent = prev; }, 1800);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAvailableDeals);
    } else {
      initAvailableDeals();
    }

    // On page load, reconcile free gifts against whatever is already in the
    // cart (e.g. a returning visitor whose cart already meets a deal's buy
    // limit) without requiring the customer to open the deal dialog first.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFreeGiftWithBuyLimit);
    } else {
      syncFreeGiftWithBuyLimit();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
